module.exports = __webpack_public_path__ + "img/ClickForSound_22.ef64b6a9.png";